




















































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { fromEvent } from 'rxjs';
import { Prop } from 'vue-property-decorator';
import BoxVoiceFv from '@/components/box/voice-fv.vue';
import TitleLarge from '@/components/title/large.vue';
import TitleMedium from '@/components/title/medium.vue';
import TextBody from '@/components/text/body.vue';
import BoxEntry from '@/components/box/entry.vue';
import LinkPageNavi from '@/components/link/page-navi.vue';
import LinkBreadcrumb from '@/components/link/breadcrumb.vue';

@Component({
  components: {
    BoxVoiceFv,
    TitleLarge,
    TitleMedium,
    TextBody,
    BoxEntry,
    LinkPageNavi,
    LinkBreadcrumb,
  },
  props: ['detail'],
})
export default class Voice extends Vue {

  /**
   * アニメーションフラグ
   */
  private isAnimate: boolean = false;

  /*
   * アニメーション終了フラグ
   */
  private isFix: boolean = false;

  /**
   * imgズレ修正
   */
  private imgBottom: number = 0;

  /**
   * mountedフック
   */
  public mounted(): void {
    // fixed解除
    const target: any = document.getElementById('pop-image');

    if (target) {
      setTimeout((): void => {
        document.body.removeChild(target);
        document.body.style.overflow = 'auto';
        this.$store.commit('setFixed', false);
        this.isAnimate = true;
      }, 100);
    } else {
      document.body.style.overflow = 'auto';
      this.$store.commit('setFixed', false);
      this.isAnimate = true;
      this.isFix = true;
    }

    window.addEventListener('resize', this.imageBottom);
    this.imageBottom();
  }

  private imageBottom(): void {
    if (this.$props.detail.pcbottom !== 'undefined' || this.$props.detail.spbottom !== 'undefined') {
      if (window.innerWidth > 767) {
        this.imgBottom = this.$props.detail.pcbottom;
      }
      if (window.innerWidth <= 767) {
        this.imgBottom = this.$props.detail.spbottom;
      }
    }
  }

}
